/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Control, Errors, Form } from 'react-redux-form';
import { Checkbox, Button, Col, ControlLabel, FormControl, FormGroup, Modal, Row } from 'react-bootstrap';
import { inviteStaff, removeStaffMember, saveStaffMember } from '../../actions/staff';
import UserTitleSelector from '../common/form/user/user-title-selector';
import UserFirstNameInput from '../common/form/user/user-first-name-input';
import UserLastNameInput from '../common/form/user/user-last-name-input';
import SearchableSelect from '../common/form/elements/searchable-select';
import ArrowButton from '../common/button-arrow';
import { validators } from '../../utils/validators';
import {Link} from "react-router-dom";

class EditStaff extends Component {
  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };
  champ = (tick, outlet) => {
    return tick && (outlet && outlet.is_champion_region)
  }
  onStaffAdded = (payLoad, selectedOutlet) => {
    const mPayLoad = {...payLoad};
    if (selectedOutlet && !selectedOutlet.is_champion_region){
      mPayLoad.is_champion = false;
    }
    if (this.props.staff_member_id !== -1) {
      this.props.dispatch(actions.submitFields('deep.staff_member', saveStaffMember(mPayLoad, this.props.saveLink, this.props.outlet, this.props.onClose)));
    } else {
      this.props.dispatch(actions.submitFields('deep.staff_member', inviteStaff(mPayLoad, this.props.outlet, this.props.onClose)));
    }
  };

  onRemoveFromStore = () => {
    this.props.dispatch(removeStaffMember(this.props.removeLink, this.props.staff_member_id, this.props.staff_member.outlet_id));
    this.props.onClose();
  };

  handleOutletChange = (event) => {
    const selectedOutlet = this.props.staff_member_relationships.outlets.find(outlet => outlet.id === event);

    if (selectedOutlet) {
      this.setState({
        outletValue: selectedOutlet.id,
        selectedOutlet: selectedOutlet
      });
    } else {
      this.setState({
        outletValue: null,
        selectedOutlet: null
      });
    }
  };

  constructor(props) {
    super(props);

    if (props.staff_member_relationships.outlets) {
      this.state = {
        outletValue: null,
        outletOptions: props.staff_member_relationships.outlets.map(outlet => (
          {
            value: outlet.id,
            label: outlet.name,
            ordering: outlet.ordering,
            reward: outlet.reward
          }
        ))
      };
    } else {
      this.state = {
        outletValue: null,
        outletOptions: []
      };
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.staff_member_relationships && nextProps.staff_member_relationships.outlets) {
      this.setState({
        outletOptions: nextProps.staff_member_relationships.outlets.map(outlet => (
          {
            value: outlet.id,
            label: outlet.name,
            ordering: outlet.ordering,
            reward: outlet.reward
          }
        ))
      });
    }

    if (nextProps.staff_member_relationships && nextProps.staff_member_relationships.outlets && nextProps.staff_member && nextProps.staff_member) {
      const selectedOutlet = nextProps.staff_member_relationships.outlets.find(outlet => outlet.id === +nextProps.staff_member.outlet_id);

      if (selectedOutlet && selectedOutlet.value !== this.state.outletValue) {
        this.setState({
          outletValue: selectedOutlet.id,
          selectedOutlet: selectedOutlet
        });
      }
    }
  }

  filterPermissions(item) {
    return item.ordering && this.state.selectedOutlet.ordering ||
    item.reward && this.state.selectedOutlet.reward ||
    !item.ordering && !item.reward
  }

  render() {
    const {
      staff_member, staff_member_id, staff_member_relationships, formValid, show, onClose, hasGoldTheme, isChampion, originalIsChampion
    } = this.props;
    const { selectedOutlet } = this.state;
    const dialogClassName = hasGoldTheme ? 'edit-staff-modal user-frontend-gold' : 'edit-staff-modal user-frontend';
    const radioButtonClassName = hasGoldTheme ? 'permissions-radio-button-box-gold' : 'permissions-radio-button-box';

    return (
      <Modal
        dialogClassName={dialogClassName}
        show={show}
        onHide={onClose}
        container={this}
        aria-labelledby="contained-modal-title"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {this.props.staff_member_id !== -1 ? "EDIT" : "ADD"} STAFF
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            model="deep.staff_member"
            validators={{
              '': {
                communication: vals => vals.email || vals.mobile,
                permissions: vals => {
                  const validity = this.champ(isChampion, selectedOutlet) || staff_member_id !== -1 ||
                  (staff_member_relationships.permissions &&
                  Object.keys(vals.permission_ids)
                  .filter((key) => vals.permission_ids[key].checked)
                  .length ===
                   staff_member_relationships.permissions.filter((item) => this.filterPermissions(item)).length);
                  return validity;
                }
              }
            }}
            onSubmit={payLoad => this.onStaffAdded(payLoad, selectedOutlet)}
          >
            <Errors className="errors" model="deep.staff_member"/>
            {selectedOutlet && selectedOutlet.is_champion_region && <Row>
              <Col lg={12}>
                <Control.checkbox className="edit-staff-checkbox" model=".is_champion" component={Checkbox} checked={isChampion}>
                  <span>Register <strong>Champion</strong> member</span>
                </Control.checkbox>
              </Col>
            </Row>}
            <Row>
              <Col lg={this.champ(isChampion, selectedOutlet)  ? 12 : 5}>
                <Row>
                  <Col lg={12}>
                    <h2>DETAILS</h2>
                  </Col>
                </Row>
                <Row>
                  <Col lg={3}>
                    <ControlLabel>Title</ControlLabel>
                  </Col>
                  <Col lg={9}>
                    <UserTitleSelector model="deep.staff_member.title" label={''} defaultValue={staff_member.title} />
                  </Col>
                </Row>
                <Row>
                  <Col lg={3}>
                  <ControlLabel>Name</ControlLabel>
                  </Col>
                  <Col lg={9}>
                    <UserFirstNameInput label={''}/>
                  </Col>
                </Row>
                <Row>
                  <Col lg={3}>
                    <ControlLabel>Surname</ControlLabel>
                  </Col>
                  <Col lg={9}>
                    <UserLastNameInput label={''}/>
                  </Col>
                </Row>
                {this.state.outletOptions.length > 0 && (
                <Row>
                <Col lg={3}>
                  <ControlLabel>Outlet</ControlLabel>
                </Col>
                <Col lg={9}>
                  <SearchableSelect
                    model="deep.staff_member.outlet_id"
                    options={this.state.outletOptions}
                    controlId="outletId"
                    value={this.state.outletValue}
                    onChange={e => this.handleOutletChange(e)}
                  />
                </Col>
              </Row>
                )}
                <Row>
                  <Col lg={3}>
                    <ControlLabel>Email</ControlLabel>
                  </Col>
                  <Col lg={9}>
                    <FormGroup controlId="email">
                      <Control model=".email" type="email" placeholder="Email" component={FormControl}/>

                      <Errors
                        show={{touched: true}}
                        className="errors"
                        model=".email"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={3}>
                    <ControlLabel>Mobile</ControlLabel>
                  </Col>
                  <Col lg={9}>
                    <FormGroup controlId="mobile">
                      <Control model=".mobile" type="tel" placeholder="Mobile" component={FormControl}/>

                      <Errors
                        show={{
                          touched: true,
                          focus: false
                        }}
                        className="errors"
                        model="deep.staff_member"
                        messages={{
                          communication: 'You must enter at least one communication preference.'
                        }}
                      />

                      <Errors
                        show={{
                          touched: true,
                          focus: false
                        }}
                        className="errors"
                        model=".mobile"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
              {!this.champ(isChampion, selectedOutlet) && <Col lg={7} className="permissions-matrix">
                <Row>
                  <Col lg={8}>
                    <h2>PERMISSIONS</h2>
                  </Col>
                  <Col lg={4}>
                    <Col lg={6} xs={4}>
                      <h2>YES</h2>
                    </Col>
                    <Col lg={6} xs={4}>
                      <h2>NO</h2>
                    </Col>
                  </Col>
                </Row>
                {
                  staff_member_relationships.outlets && staff_member_relationships.permissions && this.state.selectedOutlet &&
                  staff_member_relationships.permissions.map((item) => {
                    if (this.filterPermissions(item)) {
                      return (
                        <Row key={item.id}>
                          <Col lg={8}>
                            <ControlLabel>{item.name}</ControlLabel>
                          </Col>
                          <Col lg={4}>
                            <Col lg={6} xs={12} className="permissions-radio-button-col">
                              <div className={radioButtonClassName}>
                                <Control.radio
                                  style={{display: 'inline'}}
                                  model={`.permission_ids[${item.id}].checked`}
                                  value="true"
                                  validators={{
                                    required: validators.required(undefined, undefined)
                                  }}
                                />
                              </div>
                            </Col>
                            <Col lg={6} xs={12} className="permissions-radio-button-col">
                              <div className={radioButtonClassName}>
                                <Control.radio
                                  style={{display: 'inline'}}
                                  model={`.permission_ids[${item.id}].checked`}
                                  value="false"
                                  validators={{
                                    required: validators.required(undefined, undefined)
                                  }}
                                />
                              </div>
                            </Col>
                          </Col>
                        </Row>
                      );
                    }
                  })
                }
              </Col>}
            </Row>
            {staff_member_id === -1 && (
            <Row>
              <Col lg={12}>
                <Control.checkbox className="float-right edit-staff-checkbox" model=".agreed" component={Checkbox}>
                  <span>I confirm this {isChampion ? 'champion' : 'staff'} member is eligible to be a member of <strong>ignite</strong></span>
                </Control.checkbox>
              </Col>
            </Row>)}
            {((!originalIsChampion && isChampion) && selectedOutlet && selectedOutlet.is_champion_region) && (
              <Row>
                <Col lg={12}>
                  <Control.checkbox className="float-right edit-staff-checkbox" component={Checkbox} model=".t_cs_champion_owner">
                    <span>I agree to the champion staff terms and conditions.&nbsp;</span>
                    <Link
                      target="_blank"
                      to="/content-pages/champion-terms-conditions"
                      className="link"
                    >
                      Read here
                    </Link>

                  </Control.checkbox>
                </Col>
              </Row>)}
            <Row>
              <Col lg={12} className="edit-staff-footer">
                {staff_member_id !== -1 && (
                  <ArrowButton
                    className="remove-from-store-button"
                    arrow={false}
                    submit={false}
                    onClick={this.onRemoveFromStore}
                  >Remove from store
                  </ArrowButton>
                )}
                {staff_member_id === -1 && (
                  <Button
                  className="red-btn"
                  type="submit"
                    disabled={!staff_member.agreed || !formValid || (this.champ(isChampion, selectedOutlet) && !staff_member.t_cs_champion_owner)}
                  >Add staff member
                  </Button>
                )}
                {staff_member_id !== -1 && (
                  <Button
                    className="red-btn"
                    type="submit"
                    disabled={!formValid || (!originalIsChampion && this.champ(isChampion, selectedOutlet) && !staff_member.t_cs_champion_owner)}
                  >Save
                  </Button>
                )}
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  staff_member: state.deep.staff_member,
  staff_member_id: state.staff.staff_member_id,
  staff_member_status: state.staff.staff_member_status,
  staff_member_relationships: state.staff.staff_member_relationships,
  saveLink: state.staff.saveLink,
  removeLink: state.staff.removeLink,
  formValid: state.deep.forms.staff_member.$form.valid,
  isChampion: state.deep.forms.staff_member.is_champion.value,
  originalIsChampion: state.deep.staff_member.original_is_champion,
  hasGoldTheme: state.deep.my_profile.has_ignite_gold_outlet
});

export default connect(mapStateToProps)(EditStaff);



// WEBPACK FOOTER //
// ./src/components/my-staff/edit-staff.jsx